import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { pickChalkosContext } from "@/lib/chalkos";
import { trackChalkos } from "@/lib/analytics";

// Contextual ChalkOS module rendered near the end of Strong-fit articles only.
// Routes internally to /chalkos (the Voluntold bridge page) — never straight to an outbound signup.
export const ChalkosCTA = ({ article, placement = "article" }) => {
  const c = pickChalkosContext(article);
  if (c.relevance !== "strong") return null;

  return (
    <div className="mt-8 border-2 border-[#222222] bg-[#222222] p-6 sm:p-7" data-testid="chalkos-article-cta">
      <span className="font-head uppercase tracking-[0.2em] text-xs text-[#DB9130]">ChalkOS · a Voluntold coaching tool</span>
      <h3 className="mt-2 font-head font-semibold uppercase text-xl text-[#F5F0EA] leading-tight">{c.headline}</h3>
      <p className="mt-2 text-[#A9B6BF] text-sm leading-relaxed max-w-xl">{c.body}</p>
      <Link
        to="/chalkos"
        data-testid="chalkos-article-cta-link"
        onClick={() =>
          trackChalkos("chalkos_article_cta_click", {
            article_slug: article.slug,
            placement,
            context: c.context,
            source_page: typeof window !== "undefined" ? window.location.pathname : "",
            destination: "/chalkos",
          })
        }
        className="mt-4 inline-flex items-center gap-2 bg-[#DB9130] text-[#1A1A1A] font-head uppercase tracking-wide text-sm px-5 py-2.5 hover:bg-[#E8A33D] transition-colors"
      >
        See how ChalkOS helps <ArrowRight size={16} />
      </Link>
    </div>
  );
};

export default ChalkosCTA;
